import React from "react";
import "./../css/undefined.scss";

interface UndefinedCommandProps {
  command: string | null;
}

function DevUndefined(prop: UndefinedCommandProps) {
  const { command } = prop;

  return (
    <div className="px-4 py-2 undefined-command">
      <p className="mb-0">[{command}] is not recognized option.</p>
    </div>
  );
}

export default DevUndefined;
